import React from 'react';
import { COVERAGE_CARDS } from '../data/content';
import Icon from './Icon';
import './CoverageSection.css';

export default function CoverageSection() {
  return (
    <section className="cov-section" id="coverage">
      <div className="sec-in">
        <div className="eyebrow" style={{ color: 'var(--gold)' }}>What we cover</div>
        <div className="sec-title" style={{ color: '#fff' }}>Everything your home depends on</div>
        <div className="sec-sub" style={{ color: 'rgba(255,255,255,0.7)' }}>
          Our plans cover the parts and components of the most expensive systems
          and appliances in your home.
        </div>

        <div className="cov-grid">
          {COVERAGE_CARDS.map((card) => (
            <div key={card.title} className="cov-card">
              <div className="cov-icon">
                <Icon name={card.icon} size={26} strokeWidth={1.75} color="var(--gold)" />
              </div>
              <h3>{card.title}</h3>
              <ul className="cov-list">
                {card.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
